// src/screens/reports/salesPerMultipleCriteria.js
import React, { useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import Menu from "../../screens/menu";
import {
    Table,
    Pagination,
    Button,
    Select,
    DatePicker,
    Input,
} from "../../components";
import { axios, Globals } from "../../utils";
import { Modal as RBModal } from "react-bootstrap";
import PrinterIcon from "../../assets/icons/printer.png";
import FilterIcon from "../../assets/icons/icono_filtro.png";
import CloseIcon from "../../assets/icons/icono_cerrar.png";

const API_REPORT = "admin/reports/salesreportmultiple";

class SalesReportPerMultipleCriteria extends React.Component {
    constructor(props) {
        super(props);

        const defaultSince = moment().subtract(1, "month").startOf("day").toDate();
        const defaultUntil = moment().endOf("day").toDate();

        this.state = {
            page: 1,
            last_page: 1,
            groups: [],
            totals: { grand_total_orders: "0.00" },
            showFilters: false,
            // combos
            clients: [],
            sellers: [],
            categories: [],
            zones: [],
            paymentMethods: [],
            brands: [],
            // filtros
            form: {
                user_id: props.user.id,
                search: "",
                zone_id: "",
                client_id: "",
                seller_id: "",
                order_id: "",
                category_id: "",
                brand_id: "",
                since: defaultSince,
                until: defaultUntil,
                total_by_category: false,
                total_by_seller: false,
                total_by_product: false,
                web: true,
            },
        };
    }

    componentDidMount() {
        this.getFilters();
        this.fetchData(1);
    }

    // === Mismo getFilters que usas en tu otro reporte ===
    getFilters = () => {
        let { form } = this.state;
        form.user_id = this.props.user.id;

        axios
            .post("admin/reports/orders-filters", form)
            .then((res) => {
                const paymentMethodsMap = res.data.payment_methods.map(({ id, name }) => ({
                    value: id, label: name
                }));

                const clientsMap = res.data.clients.map(({ id, name }) => ({
                    value: id, label: name
                }));

                const sellersMap = [
                    ...res.data.sellers,
                    ...res.data.managers,
                    ...res.data.moderators,
                ].map(item => {
                    const isDeleted = !!(
                        item.is_deleted ||
                        item.deleted ||
                        item.deleted_at != null ||
                        (item.status !== undefined && (item.status === 0 || item.status === '0'))
                    );
                    return {
                        value: item.id,
                        label: item.name,
                        is_deleted: isDeleted,
                        style: isDeleted ? { color: 'gray' } : {},
                    };
                });

                const zonesMap = res.data.zones.map(({ id, name }) => ({
                    value: id, label: name
                }));

                const categoriesMap = (res.data.categories || []).map(({ id, name }) => ({
                    value: id, label: name
                }));

                const brandsMap = (res.data.brands || []).map(({ id, name }) => ({
                    value: id, label: name
                }));

                this.setState({
                    paymentMethods: paymentMethodsMap,
                    clients: clientsMap,
                    sellers: sellersMap,
                    zones: zonesMap,
                    categories: categoriesMap,
                    brands: brandsMap,
                });
            })
            .catch(() => { });
    };

    // --- Fetch del reporte ---
    fetchData = async (resetPage = null) => {
        try {
            Globals.setLoading();
            let page = this.state.page;
            if (typeof resetPage === "number") page = resetPage;

            const form = { ...this.state.form };
            form.user_id = this.props.user.id;
            form.since = form.since ? moment(form.since).format("YYYY-MM-DD") : "";
            form.until = form.until ? moment(form.until).format("YYYY-MM-DD") : "";
            form.web = true;

            const res = await axios.post(`${API_REPORT}?page=${page}`, form);
            const groups = res.data.groups || [];
            const totals = res.data.totals || { grand_total_orders: "0.00" };
            const last_page = res.data.pagination?.last_page ?? 1;

            this.setState({ groups, totals, page, last_page });
        } catch (e) {
            Globals.showError("Ocurrió un error al cargar el reporte.");
        } finally {
            Globals.quitLoading();
        }
    };

    // --- Descargar PDF (usa mismo payload + download:true) ---
    download = async () => {
        try {
            Globals.setLoading();
            const form = { ...this.state.form };
            form.user_id = this.props.user.id;
            form.since = form.since ? moment(form.since).format("YYYY-MM-DD") : "";
            form.until = form.until ? moment(form.until).format("YYYY-MM-DD") : "";
            form.web = true;
            form.download = true;
            form.type_download = 'excel'; //pdf o excel

            const res = await axios.post(API_REPORT, form);
            if (res.data?.file) {
                const win = window.open(res.data.file, "_blank");
                if (win) win.focus();
            } else {
                Globals.showError("No se pudo generar el archivo.");
            }
        } catch {
            Globals.showError("Ocurrió un error al generar el archivo.");
        } finally {
            Globals.quitLoading();
        }
    };

    render() {
        const { groups, totals, last_page, page, showFilters, form } = this.state;

        return (
            <Menu history={this.props.history}>
                {showFilters && (
                    <RBModal
                        tabIndex="0"
                        size="lg"
                        show
                        onHide={() => this.setState({ showFilters: false })}
                        backdropClassName="custom-modal-bd"
                        contentClassName="custom-modal-content"
                    >
                        <RBModal.Body>
                            <img
                                src={CloseIcon}
                                alt="Cerrar"
                                className="close-btn"
                                onClick={() => this.setState({ showFilters: false })}
                            />

                            <Filters
                                form={form}
                                clients={this.state.clients}
                                sellers={this.state.sellers}
                                categories={this.state.categories}
                                brands={this.state.brands}
                                zones={this.state.zones}
                                onSearch={async (filters, close = false) => {
                                    await this.setState(s => ({
                                        ...(close ? { showFilters: false } : {}),
                                        page: 1,
                                        form: { ...s.form, ...filters },
                                    }));
                                    this.fetchData(1);
                                }}
                                onClose={() => this.setState({ showFilters: false })}
                            />
                        </RBModal.Body>
                    </RBModal>
                )}

                <div className="new-reports">
                    <div className="row" style={{ maxWidth: 600, margin: "0 0 20px 0", textAlign: "left" }}>
                        <div className="col-sm-6 total-amount">
                            <div className="container-total cyan">
                                <span>RANGO</span>
                                <div>
                                    {form.since ? moment(form.since).format("DD/MM/YYYY") : "-"} —{" "}
                                    {form.until ? moment(form.until).format("DD/MM/YYYY") : "-"}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Solo encabezado/acciones */}
                    <Table
                        data={groups.length}
                        title="Ventas"
                        header={[
                        ]}
                        right={
                            <div style={{ display: "flex", gap: "1rem" }}>
                                <Button small title="Filtrar" onClick={() => this.setState({ showFilters: true })}>
                                    <img src={FilterIcon} alt="Filtrar" />
                                </Button>
                                <Button small title="Imprimir" onClick={this.download}>
                                    <img src={PrinterIcon} alt="Imprimir" />
                                </Button>
                            </div>
                        }
                    />

                    {/* Lista completa por vendedor, fuera del <Table> */}
                    <div className="seller-list">
                        {groups.length === 0 ? (
                            <div className="empty-state">No ha realizado búsqueda en los filtros</div>
                        ) : (
                            groups.map(group => (
                                <SellerBlock key={group.seller_id} group={group} form={form} />
                            ))
                        )}
                    </div>

                    <Pagination
                        pages={last_page}
                        active={page}
                        onChange={async p => {
                            await this.setState({ page: p });
                            this.fetchData(p);
                        }}
                    />
                </div>

                {/* Estilos auxiliares y print-safe */}
                <style>{`
          .empty-state{ text-align:center; padding:20px; color:#777; }
          .seller-list{ margin-top:8px; }
          .totals-row{ display:flex; align-items:center; gap:18px; white-space:nowrap; margin-top:8px; }
          .totals-row label{ display:flex; align-items:center; gap:6px; font-size:13px; margin:0; }
          .filters-footer{ display:flex; justify-content:flex-end; gap:12px; padding:16px 24px 8px; }
          .btn-filter{ min-width:120px; }
          @media print {
            .seller-box { page-break-inside: avoid; }
            .seller-head { page-break-after: avoid; }
          }
        `}</style>
            </Menu>
        );
    }
}

// === Bloque por vendedor ===
const SellerBlock = ({ group, form }) => {
    const showSeller = !!form.total_by_seller;
    const showCat = !!form.total_by_category && (group.totals?.by_category?.length || 0) > 0;
    const showProd = !!form.total_by_product && (group.totals?.by_product?.length || 0) > 0;

    return (
        <div className="seller-box" style={{ border: "1px solid #e7e7e7", borderRadius: 8, margin: 8, background: "#fff" }}>
            <div className="seller-head" style={{ background: "#0f2d5c", color: "#fff", padding: "8px 12px", borderRadius: "8px 8px 0 0", fontWeight: 700 }}>
                Vendedor: <span style={{ fontWeight: 800 }}>{group.seller_name}</span>
            </div>

            {/* tabla de filas por producto */}
            <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                        <tr style={{ background: "#f6f7fb" }}>
                            <th style={{...th, width: 100}}>Zona</th>
                            <th style={{...th, width: 100}}>Categoría</th>
                            <th style={{...th, width: 100}}>Marca</th>
                            <th style={{ ...th, width: 250 }}>Cliente</th>
                            <th style={{ ...th, width: 80 }}>ID pedido</th>
                            <th style={{ ...th, width: 120 }}>Fecha</th>
                            <th style={{ ...th, width: 250 }}>Producto</th>
                            <th style={{ ...th, textAlign: "right", width: 90 }}>Cantidad</th>
                            <th style={{ ...th, textAlign: "right", width: 100 }}>Total ($)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {group.rows.map((r, idx) => (
                            <tr key={idx}>
                                <td style={{...td, width: 100}}>{r.zone || ""}</td>
                                <td style={{...td, width: 100}}>{r.category || ""}</td>
                                <td style={{...td, width: 100}}>{r.brand || ""}</td>
                                <td style={{...td, width: 250}}>{r.client || ""}</td>
                                <td style={{ ...td, width: 80 }}>{r.correlative_number || r.order_id}</td>
                                <td style={{ ...td, width: 120 }}>{r.order_date ?? ''}</td>
                                <td style={{ ...td, width: 250 }}>{r.product_name}</td>
                                <td style={{ ...td, textAlign: "right" }}>{ Globals.formatMiles(r.quantity) }</td>
                                <td style={{ ...td, textAlign: "right" }}>{ Globals.formatMiles(r.line_total)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* SUBTOTALES */}
            <div style={{ padding: "8px 10px 12px" }}>
                {showSeller && (
                    <table style={{ width: "100%", marginTop: 10, borderCollapse: "collapse" }}>
                        <thead>
                            <tr><th colSpan={2} style={subTitle}>Total vendedor</th></tr>
                        </thead>
                        <tbody>
                            <tr style={{ background: "#111a3a", color: "#fff", fontWeight: 700 }}>
                                <td style={{ padding: "6px 8px" }}>{group.seller_name}</td>
                                <td style={{ padding: "6px 8px", textAlign: "right" }}>{Globals.formatMiles(group.totals?.seller_total )|| "0.00"}</td>
                            </tr>
                        </tbody>
                    </table>
                )}

                {showCat && (
                    <table style={{ width: "100%", marginTop: 10, borderCollapse: "collapse" }}>
                        <thead>
                            <tr><th colSpan={3} style={subTitle}>Total por categoría</th></tr>
                            <tr style={{ background: "#f6f7fb" }}>
                                <th style={th}>Categoría</th>
                                <th style={{ ...th, textAlign: "right", width: 100 }}>Cantidad</th>
                                <th style={{ ...th, textAlign: "right", width: 120 }}>Total ($)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {group.totals.by_category.map((c, i) => (
                                <tr key={i}>
                                    <td style={td}>{c.category_name || "Sin categoría"}</td>
                                    <td style={{ ...td, textAlign: "right" }}>{ Globals.formatMiles(c.qty) }</td>
                                    <td style={{ ...td, textAlign: "right" }}>{Globals.formatMiles(c.total)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                {showProd && (
                    <table style={{ width: "100%", marginTop: 10, borderCollapse: "collapse" }}>
                        <thead>
                            <tr><th colSpan={3} style={subTitle}>Total por producto</th></tr>
                            <tr style={{ background: "#f6f7fb" }}>
                                <th style={th}>Producto</th>
                                <th style={{ ...th, textAlign: "right", width: 100 }}>Cantidad</th>
                                <th style={{ ...th, textAlign: "right", width: 120 }}>Total ($)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {group.totals.by_product.map((p, i) => (
                                <tr key={i}>
                                    <td style={td}>{p.product_name}</td>
                                    <td style={{ ...td, textAlign: "right" }}>{ Globals.formatMiles(p.qty) }</td>
                                    <td style={{ ...td, textAlign: "right" }}>{Globals.formatMiles(p.total)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

// estilos base para celdas de tablas internas
const th = { fontWeight: 700, fontSize: 12, padding: "6px 8px", borderBottom: "1px solid #e5e7ef", textAlign: "left" };
const td = { fontSize: 12, padding: "6px 8px", borderBottom: "1px solid #f0f1f6", textAlign: "left" };
const subTitle = { fontWeight: 700, fontSize: 13, padding: "6px 8px", background: "#e6e9f2", textAlign: "left" };

// === Modal de filtros ===
const Filters = ({ form, clients, sellers, categories, brands, zones, onSearch }) => {
    const searchTimeout = React.useRef(null);
    React.useEffect(() => {
        return () => {
            if (searchTimeout.current) clearTimeout(searchTimeout.current);
        };
    }, []);

    const [f, setF] = useState({
        search: form.search || "",
        zone_id: form.zone_id || "",
        client_id: form.client_id || "",
        seller_id: form.seller_id || "",
        order_id: form.order_id || "",
        category_id: form.category_id || "",
        brand_id: form.brand_id || "",
        since: form.since || moment().subtract(1, "month").startOf("day").toDate(),
        until: form.until || moment().endOf("day").toDate(),
        total_by_category: !!form.total_by_category,
        total_by_seller: !!form.total_by_seller,
        total_by_product: !!form.total_by_product,
    });

    const autoFilter = (newForm, isText = false) => {
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        if (isText) {
            searchTimeout.current = setTimeout(() => {
                onSearch(newForm, false);
            }, 700);
        } else {
            onSearch(newForm, false);
        }
    };

    const onChange = (value, target, isText = false) => {
        setF(s => {
            const next = { ...s, [target]: value };
            autoFilter(next, isText);
            return next;
        });
    };

    const reset = () => {
        const initial = {
            search: "",
            client_id: "",
            seller_id: "",
            order_id: "",
            category_id: "",
            brand_id: "",
            zone_id: "",
            since: moment().subtract(1, "month").startOf("day").toDate(),
            until: moment().endOf("day").toDate(),
            total_by_category: false,
            total_by_seller: false,
            total_by_product: false,
        };
        setF(initial);
        onSearch(initial, false);
    };

    return (
        <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "0 1rem", padding: "1rem 2rem 0" }}>
                {/* Fila 1: Desde, Hasta, ID */}
                <div>
                    <DatePicker
                        color="white"
                        label="Desde"
                        className="filter"
                        value={f.since}
                        onChange={v => onChange(v, "since", false)}
                    />
                </div>
                <div>
                    <DatePicker
                        color="white"
                        label="Hasta"
                        className="filter"
                        value={f.until}
                        onChange={v => onChange(v, "until", false)}
                    />
                </div>
                <div>
                    <Input
                        color=" "
                        label="N° de pedido"
                        className="filter"
                        value={f.order_id}
                        onChange={v => onChange(v.target.value, "order_id", true)}
                    />
                </div>

                {/* Fila 2: Cliente, Vendedor, Categoría */}
                <div>
                    <Select
                        color="white"
                        label="Cliente"
                        className="filter"
                        truncateLabel={27}
                        style={{ textTransform: "capitalize" }}
                        onChange={e => onChange(e.target.value, "client_id")}
                        value={f.client_id}
                        options={clients}
                    />
                </div>
                <div>
                    <Select
                        color="white"
                        label="Vendedor"
                        className="filter"
                        style={{ textTransform: "capitalize" }}
                        onChange={e => onChange(e.target.value, "seller_id")}
                        value={f.seller_id}
                        options={sellers}
                    />
                </div>
                <div>
                    <Select
                        color="white"
                        label="Categoría"
                        className="filter"
                        style={{ textTransform: "capitalize" }}
                        onChange={e => onChange(e.target.value, "category_id")}
                        value={f.category_id}
                        options={categories}
                    />
                </div>

                {/* Fila 3: Marca, Zona, Búsqueda */}
                <div>
                    <Select
                        color="white"
                        label="Marca"
                        className="filter"
                        style={{ textTransform: "capitalize" }}
                        onChange={e => onChange(e.target.value, "brand_id")}
                        value={f.brand_id}
                        options={brands}
                    />
                </div>
                <div>
                    <Select
                        color="white"
                        label="Zona"
                        className="filter"
                        style={{ textTransform: "capitalize" }}
                        onChange={e => onChange(e.target.value, "zone_id")}
                        value={f.zone_id}
                        options={zones}
                    />
                </div>
                <div>
                    <Input
                        color=" "
                        label="Búsqueda"
                        className="filter"
                        value={f.search}
                        onChange={v => onChange(v.target.value, "search", true)}
                        placeholder={"Búsqueda por producto, categoría, marca, modelo"}
                    />
                </div>
                <div /> {/* hueco vacío para completar 3 columnas */}
            </div>

            {/* Totales en una sola línea */}
            <div className="totals-row" style={{ padding: "0.2rem 2rem 0.6rem" }}>
                <label>
                    <input
                        type="checkbox"
                        checked={f.total_by_category}
                        onChange={e => onChange(e.target.checked, "total_by_category", false)}
                    />
                    <span>Total por Categoría</span>
                </label>
                <label>
                    <input
                        type="checkbox"
                        checked={f.total_by_seller}
                        onChange={e => onChange(e.target.checked, "total_by_seller", false)}
                    />
                    <span>Total por Vendedor</span>
                </label>
                <label>
                    <input
                        type="checkbox"
                        checked={f.total_by_product}
                        onChange={e => onChange(e.target.checked, "total_by_product", false)}
                    />
                    <span>Total por Producto</span>
                </label>
            </div>

            {/* Botones centrados */}
            <div className="filters-footer">
                <Button
                    className="btn-align-bottom btn-filter"
                    style={{ minWidth: 110, maxWidth: 110 }}
                    color=" "
                    onClick={reset}
                >
                    <span>Limpiar</span>
                </Button>
            </div>
        </>
    );
};


export default connect((state) => ({ user: state.user }))(SalesReportPerMultipleCriteria);
